import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useMutationReorderRankForStoredFilterBulkAssignTags } from 'api/mutations/reorderRankForStoredFilterBulkAssignTags.mutation';
import {
    QueryResponse,
    useQueryGetStoredFilterBulkAssignOrRemoveTags,
} from 'api/queries/getStoredFilterBulkAssignOrRemoveTags.query';

import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { DndTable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/DndTable/dndTable';
import {
    columns,
    reorderRows,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkTagsRules/editBulkTagsRules.utils';

export const EditBulkTagsRules = () => {
    const { contract } = useProjectTreeStore();
    const { handleSnackBar } = useCustomSnackBar();

    const { data, refetch } = useQueryGetStoredFilterBulkAssignOrRemoveTags({ contractId: contract?.id });

    const { mutate } = useMutationReorderRankForStoredFilterBulkAssignTags();

    const handleRankReorder = (arr: QueryResponse['tagAssignRule']) => {
        if (!contract) return null;

        const payload = reorderRows<QueryResponse['tagAssignRule'][0]>(arr);

        mutate(
            {
                idList: payload,
                contractId: contract.id,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully Reordered!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    refetch();
                },
            },
        );
    };

    return (
        <WidgetWithTitle title={'Bulk Assign Tags Rules'} tooltip={data?.info}>
            {data && (
                <DndTable<QueryResponse['tagAssignRule'][0]>
                    columns={columns}
                    data={data?.tagAssignRule}
                    handleRankReorder={handleRankReorder}
                />
            )}
        </WidgetWithTitle>
    );
};
